import { useEffect, createContext } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Button,
  Modal,
  Space,
  Spin,
  Card,
  Row,
  Col,
  Flex,
  Dropdown,
  MenuProps,
} from "antd";

import { DownOutlined } from "@ant-design/icons";

import ObjectForm from "components/Admin/ObjectForm";

import { RootState } from "Redux/store";
import { fetchActionItem, updateActionItem, createActionItem, deleteActionItem } from "Redux/Admin/ProjectManager/ActionItems/action";

import { settings, initialSettings, initialValues } from './const';
import { ADMIN_PATH } from "utils/routes";

import type { IActionItem } from 'Redux/Admin/ProjectManager/ActionItems/type';

const ActionItem = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { id } = useParams<{ id: string }>();
  const isNew = id === 'new';

  const { entities, loading, error } = useSelector((state: RootState) => state.fetchActionItems);

  const [modal, contextHolder] = Modal.useModal();

  const ReachableContext = createContext<string | null>(null);

  useEffect(() => {
    if (id && !isNew) {
      dispatch(fetchActionItem(id));
    }
  }, [dispatch, isNew, id]);

  const onFinish = (values: any) => {
    if (isNew) {
      dispatch(createActionItem(values, handleCreate));
    }
    else if (id) {
      dispatch(updateActionItem(values, id));
    }
  };

  const handleCreate = (project: IActionItem) => {
    if (project && project.id) {
      navigate(`${ADMIN_PATH}/project-manager/action-items/${project.id}`);
    }
  }

  if (!id) {
    navigate(`${ADMIN_PATH}/project-manager/action-items`, { replace: true });
    return null;
  }

  const actionItem = isNew ? initialValues : entities[id];

  if (!actionItem) {
    return <Spin />;
  }

  const menuItems: MenuProps['items'] = [
    /* {
      label: 'View Areas',
      key: '1',
    }, */
    {
      label: 'Delete Action Item',
      key: '2',
      danger: true,
    }
  ];

  const modalConfig = {
    title: 'Delete the action item?',
    content: <span>Are you sure you want to delete the action item <b>{actionItem.id}</b>?</span>,
    confirmLoading: true
  };

  const handleMenuClick: MenuProps['onClick'] = async (e) => {
    /* if (e.key === '1') {
      navigate(`${ADMIN_PATH}/goals/journeys/user-areas/?masterplan=${id}`);
    }
    else  */if (e.key === '2') {
      const confirmed = await modal.confirm(modalConfig);

      if (confirmed) {
        dispatch(deleteActionItem(id, () => {
          navigate(`${ADMIN_PATH}/project-manager/action-items`, { replace: true });
        }));
      }
    }
  };

  const menuProps = {
    items: menuItems,
    onClick: handleMenuClick,
  };

  return (
    <ReachableContext.Provider value="Light">
      <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
        <Row>
          <Col span={12}>
            <Flex
              gap="middle"
              align="center"
              justify="space-between"
              style={{ marginBottom: 16 }}
            >
              <Link to={`${ADMIN_PATH}/project-manager/action-items`}>Back</Link>
            </Flex>

            <Card title={`${isNew ? 'Create' : '' } Action Item`} extra={
              isNew ? null : <Dropdown menu={menuProps} placement="bottom">
                <Button>
                  <Space>
                    Manage Action Item
                    <DownOutlined />
                  </Space>
                </Button>
              </Dropdown>
            }>
              <ObjectForm
                data={actionItem}
                errorData={error}
                isNew={isNew}
                settings={isNew ? initialSettings : settings}
                loading={loading}
                onFinish={onFinish}
              />
            </Card>
          </Col>
        </Row>
      </div>

      {contextHolder}
    </ReachableContext.Provider>
  );
}

export default ActionItem;
